export const SET_EMAIL = 'GET_STARTED.SET_EMAIL'
